import type { User, UserReference } from '@recruitee/account-types';
import type { Attachment } from '@recruitee/attachments-types';
import type { Reactions } from '@recruitee/reactions-types';
import type { Visibility } from '@recruitee/visibility-types';

export type Guest = {
  authToken: string;
  createdAt: string;
  email: string;
  id: number;
  name: string;
  photoThumbUrl: string;
  recruiter: boolean;
  updatedAt: string;
  initials?: string;
  hasAvatar?: boolean;
};

export interface GuestReference extends Guest {
  type: 'Guest';
}

export type NoteAssignment = {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  photoNormalUrl: string;
  photoThumbUrl: string;
  timezone: string;
};

export const NEW_NOTE_ID = 'NEW_CANDIDATE_NOTE';
export type NoteId = number | typeof NEW_NOTE_ID;

export type Note = {
  admin: User | null;
  adminId: number | null;
  attachments: NoteAttachment[];
  body: string;
  bodyJson: object;
  candidateId: null;
  createdAt: string;
  guestId: number | null;
  guest: Guest | null;
  id: NoteId | null;
  noteAssignments: NoteAssignment[];
  offerId: number | null;
  talentPoolId: number | null;
  pinnedAt: string | null;
  private?: boolean;
  reactions: Reactions;
  replies: Note[];
  repliesIds: number[];
  replyToId: number | null;
  requisitionId: number | null;
  text: string;
  triggered: boolean | null;
  updatedAt: string;
  visibility: Visibility;
};

export type NoteReferences = GuestReference | UserReference;

export type NotePayload = {
  body: string;
  adminIds?: number[];
  id?: number | null;
  replyToId?: number | null;
  private?: boolean;
};

type NoteAttachment = Attachment & { noteId: number; kind: string };
